export enum ServicesProvidedType {
    IMPORTING_QC_LICENCE = 'IMPORTING_QC_LICENCE',
    IMPORTING_CUSTOMER_LICENCE = 'IMPORTING_CUSTOMER_LICENCE',
    QA_SUPPORT = 'QA_SUPPORT',
    CANADIAN_QUALITY_UNIT = 'CANADIAN_QUALITY_UNIT',
    // Legacy values - kept for backward compatibility with existing data
    QCO_SERVICES = 'QCO_SERVICES',
    QA_REGULATORY_SUPPORT = 'QA_REGULATORY_SUPPORT',
    FULL_REGULATORY_COMPLIANCE = 'FULL_REGULATORY_COMPLIANCE',
    CUSTOM_SERVICES = 'CUSTOM_SERVICES',
    IMPORTING_QUALITY_SERVICES = 'IMPORTING_QUALITY_SERVICES',
}

export const ServicesProvidedLabels = {
    [ServicesProvidedType.IMPORTING_QC_LICENCE]: 'Importing (Q&C Licence)',
    [ServicesProvidedType.IMPORTING_CUSTOMER_LICENCE]: 'Importing (Customer Licence)',
    [ServicesProvidedType.QA_SUPPORT]: 'QA Support',
    [ServicesProvidedType.CANADIAN_QUALITY_UNIT]: 'Canadian Quality Unit',
    // Legacy labels
    [ServicesProvidedType.QCO_SERVICES]: 'Quality Control Officer (QCO) services',
    [ServicesProvidedType.QA_REGULATORY_SUPPORT]: 'Quality Assurance and Regulatory Affairs support',
    [ServicesProvidedType.FULL_REGULATORY_COMPLIANCE]: 'Full regulatory compliance and quality oversight',
    [ServicesProvidedType.CUSTOM_SERVICES]: 'Custom services',
    [ServicesProvidedType.IMPORTING_QUALITY_SERVICES]: 'Importing Quality Services',
};
